export default __webpack_public_path__ + "static/media/731.03fbd4a7.png";